import { z } from 'zod';
import { isoTimestamp, pageQuery, severity, sourceType, uuid } from './primitives.js';
import { monitorConfig, monitorState } from './monitors.js';
/**
 * A source is an ingesting system (Prometheus, a cron job, a mesh node).
 * It authenticates with a bearer token that is stored hashed and shown once.
 */
export const source = z.object({
    id: uuid,
    key: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    type: sourceType,
    default_severity: severity,
    is_active: z.boolean(),
    token_last_four: z.string().nullable(),
    token_rotated_at: isoTimestamp.nullable(),
    last_alert_at: isoTimestamp.nullable(),
    alert_count: z.number().int(),
    /** Nur bei type = monitor gesetzt. */
    monitor: monitorConfig.nullish(),
    monitor_state: monitorState.nullish(),
    next_check_at: isoTimestamp.nullish(),
    created_at: isoTimestamp,
    updated_at: isoTimestamp,
});
export const sourceKey = z
    .string()
    .min(2)
    .max(64)
    .regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/, 'Nur Kleinbuchstaben, Ziffern und Bindestriche');
export const createSourceBody = z.object({
    key: sourceKey,
    name: z.string().min(1).max(120),
    description: z.string().max(2000).nullish(),
    type: sourceType.default('generic'),
    default_severity: severity.default('warning'),
});
export const updateSourceBody = z
    .object({
    name: z.string().min(1).max(120),
    description: z.string().max(2000).nullable(),
    type: sourceType,
    default_severity: severity,
    is_active: z.boolean(),
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, { message: 'Mindestens ein Feld erforderlich' });
/** The plaintext token exists exactly once, in the response that created it. */
export const sourceWithToken = source.extend({
    token: z.string(),
    ingest_url: z.string(),
});
export const listSourcesQuery = pageQuery.extend({
    is_active: z.stringbool().optional(),
});
//# sourceMappingURL=sources.js.map